import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { STOGarantBanner } from '../components/STOGarantBanner';
import { CheckIcon } from 'lucide-react';
import { ImageGallery } from '../components/ImageGallery';
export default function GreecePage() {
  const zakynthosImages = [{
    src: 'https://images.unsplash.com/photo-1597520051247-7c333d694c7c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Navagio Beach (Shipwreck Beach) in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1591470482780-40c1d410eb6e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Blue Caves in Zakynthos'
  }, {
    src: 'https://images.unsplash.com/photo-1602513850041-58e73ffd3a57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    alt: 'Zakynthos coastline with clear turquoise waters'
  }, {
    src: 'https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80',
    alt: 'Hiking trail in Zakynthos mountains'
  }];
  const visualImpressions = [{
    src: 'https://images.unsplash.com/photo-1586861256632-52a3db3369be?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Olive groves hiking trail',
    description: 'Peaceful hiking through ancient olive groves with views of the Ionian Sea'
  }, {
    src: 'https://images.unsplash.com/photo-1580757746866-2f68fae4d6d9?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Mountain village in Zakynthos',
    description: "Discover authentic Greek culture in Zakynthos' traditional mountain villages"
  }, {
    src: 'https://images.unsplash.com/photo-1554629947-334ff61d85dc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1036&q=80',
    alt: 'Cliff-top viewpoint',
    description: 'Breathtaking viewpoints that reward your hiking efforts with panoramic vistas'
  }, {
    src: 'https://images.unsplash.com/photo-1533105079780-92b9be482077?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    alt: 'Hidden beach cove',
    description: 'Access secluded beaches and coves that can only be reached on foot'
  }];
  return <div className="flex flex-col min-h-screen w-full" data-id="element-438">
      <Header data-id="element-439" />
      <main className="flex-grow" data-id="element-440">
        {/* Hero Section */}
        <section className="relative w-full h-[60vh] bg-cover bg-center" data-id="element-441">
          <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: "url('https://uploadthingy.s3.us-west-1.amazonaws.com/uduAPmpJaYxr7pWgGXQtvs/high-angle-view-swimming-pool.jpg')"
        }} data-id="element-442">
            <div className="absolute inset-0 bg-black bg-opacity-40" data-id="element-443"></div>
          </div>
          <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-444">
            <div className="max-w-3xl text-white" data-id="element-445">
              <h1 className="text-5xl md:text-6xl font-bold mb-6" data-id="element-446">
                Walking holidays Greece
              </h1>
              <p className="text-lg md:text-xl mb-8" data-id="element-447">
                Greece is a country where natural beauty, rich history, and
                vibrant culture come together to create a truly unique
                destination. Its landscapes, from rugged mountains to sun-soaked
                coastlines, provide the perfect backdrop for outdoor adventures,
                especially hiking. But Greece is more than just its stunning
                scenery—it's a land steeped in history, with ancient ruins,
                historic villages, and centuries-old traditions that continue to
                thrive. Whether walking along coastal paths or through olive
                groves, travelers are often surrounded by remnants of Greece's
                storied past.
              </p>
              <a href="/join" className="bg-teal-600 hover:bg-teal-700 text-white font-medium py-3 px-6 rounded-md text-center inline-block transition duration-300" data-id="element-448">
                Join a Trip
              </a>
            </div>
          </div>
        </section>
        {/* Trip Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-449">
          <div className="container mx-auto px-4" data-id="element-450">
            <div className="text-center mb-12" data-id="element-451">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-452">
                Our Greece Hiking Trips
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-453">
                Explore the stunning landscapes and rich culture of Greece with
                our guided hiking tours
              </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-454">
              {/* Trip 1 */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-455">
                <div className="relative h-64" data-id="element-456">
                  <img src="https://images.unsplash.com/photo-1570077188670-e3a8d69ac5ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80" alt="Zakynthos in spring" className="w-full h-full object-cover" data-id="element-457" />
                </div>
                <div className="p-6" data-id="element-458">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-459">
                    Zakynthos in spring
                  </h3>
                  <p className="text-teal-600 font-semibold mb-4" data-id="element-460">
                    New dates coming soon
                  </p>
                  <p className="text-gray-600 mb-6" data-id="element-461">
                    Walk along cliffs, olive groves, and peaceful villages, far
                    from the crowds. Discover the quiet beauty of Zakynthos in
                    spring.
                  </p>
                  <div className="space-y-2 mb-6" data-id="element-462">
                    <div className="flex items-start" data-id="element-463">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-464" />
                      <span className="text-gray-700" data-id="element-465">
                        Small group (max. 12 people)
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-466">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-467" />
                      <span className="text-gray-700" data-id="element-468">
                        Local guide with in-depth island knowledge
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-469">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-470" />
                      <span className="text-gray-700" data-id="element-471">
                        Varied hikes, from coastal trails to mountain villages
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-800 font-medium mb-6" data-id="element-472">
                    8-day hiking trip from € 695,- per person
                  </p>
                  <a href="/trips/zakynthos-spring" className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-473">
                    View Details
                  </a>
                </div>
              </div>
              {/* Trip 2 */}
              <div className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-474">
                <div className="relative h-64" data-id="element-475">
                  <img src="https://images.unsplash.com/photo-1602513850041-58e73ffd3a57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=987&q=80" alt="Zakynthos in autumn" className="w-full h-full object-cover" data-id="element-476" />
                </div>
                <div className="p-6" data-id="element-477">
                  <h3 className="text-2xl font-bold text-gray-800 mb-2" data-id="element-478">
                    Zakynthos in autumn
                  </h3>
                  <p className="text-teal-600 font-semibold mb-4" data-id="element-479">
                    03 - 10 September 2025
                  </p>
                  <p className="text-gray-600 mb-6" data-id="element-480">
                    Walk along cliffs, olive groves, and peaceful villages, far
                    from the crowds. Discover the quiet beauty of Zakynthos in
                    spring.
                  </p>
                  <div className="space-y-2 mb-6" data-id="element-481">
                    <div className="flex items-start" data-id="element-482">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-483" />
                      <span className="text-gray-700" data-id="element-484">
                        Small group (max. 12 people)
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-485">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-486" />
                      <span className="text-gray-700" data-id="element-487">
                        Local guide with in-depth island knowledge
                      </span>
                    </div>
                    <div className="flex items-start" data-id="element-488">
                      <CheckIcon size={20} className="text-teal-600 mr-2 mt-1 flex-shrink-0" data-id="element-489" />
                      <span className="text-gray-700" data-id="element-490">
                        Varied hikes, from coastal trails to mountain villages
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-800 font-medium mb-6" data-id="element-491">
                    8-day hiking trip from € 695,- per person
                  </p>
                  <a href="/trips/zakynthos-autumn" className="block text-center bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-4 rounded-md transition duration-300" data-id="element-492">
                    View Details
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Zakynthos Gallery Section */}
        <section className="py-16 w-full" data-id="element-493">
          <div className="container mx-auto px-4" data-id="element-494">
            <ImageGallery images={zakynthosImages} data-id="element-495" />
            <div className="max-w-4xl mx-auto mt-12" data-id="element-496">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6" data-id="element-497">
                Walking holidays Zakynthos
              </h2>
              <p className="text-lg text-gray-700 mb-6" data-id="element-498">
                Known for its crystal-clear waters, towering cliffs, and hidden
                beaches, is one of Greece's most beautiful islands. Beyond its
                famous shipwreck beach, the island is a hiker's paradise, with
                winding mountain trails, scenic viewpoints, and charming
                villages to explore.
              </p>
              <p className="text-lg text-gray-700 mb-6" data-id="element-499">
                Our hiking trips in Zakynthos are designed to let you experience
                the island's natural wonders up close, with hikes ranging from
                4km to 8km depending on the season. We keep our group sizes
                intimate—about 5 to 15 people—so you can enjoy a more personal
                and immersive experience. Led by an experienced local guide who
                knows the hidden gems of Zakynthos, you'll explore remote
                mountain trails, uncover breathtaking views, and learn about the
                island's rich history and culture.
              </p>
              <p className="text-lg italic text-gray-600 mb-6" data-id="element-500">
                This offer is covered by the STO Garant guarantee. You can find
                the conditions for this guarantee scheme on STO Garant's website
                (www.sto-garant.nl/en/downloads).
              </p>
            </div>
          </div>
        </section>
        {/* Visual Impression Section */}
        <section className="py-16 bg-gray-50 w-full" data-id="element-501">
          <div className="container mx-auto px-4" data-id="element-502">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-12 text-center" data-id="element-503">
              A Visual Impression
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-504">
              {visualImpressions.map((image, index) => <div key={index} className="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-lg transition duration-300" data-id="element-505">
                  <div className="h-64 overflow-hidden" data-id="element-506">
                    <img src={image.src} alt={image.alt} className="w-full h-full object-cover transform hover:scale-105 transition duration-500" data-id="element-507" />
                  </div>
                  <div className="p-4" data-id="element-508">
                    <p className="text-gray-700" data-id="element-509">{image.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </section>
        <STOGarantBanner data-id="element-510" />
      </main>
      <Footer data-id="element-511" />
    </div>;
}